var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlacepin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:location-dot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.5 6.63959C0.5 7.17675 0.695278 7.86726 1.05245 8.66249C1.40557 9.44871 1.89752 10.2954 2.44661 11.1326C3.54426 12.8062 4.84353 14.4018 5.63977 15.3384C5.82454 15.5539 6.17546 15.5539 6.36023 15.3384C7.15647 14.4018 8.45574 12.8062 9.55339 11.1326C10.1025 10.2954 10.5944 9.44871 10.9476 8.66249C11.3047 7.86726 11.5 7.17675 11.5 6.63959C11.5 3.83094 9.06599 1.5 6 1.5C2.93401 1.5 0.5 3.83094 0.5 6.63959ZM4.24334 4.946C4.71422 4.50341 5.34661 4.25973 6 4.25973C6.65339 4.25973 7.28578 4.50341 7.75666 4.946C8.22858 5.38958 8.5 5.99807 8.5 6.63959C8.5 7.28112 8.22858 7.8896 7.75666 8.33319C7.28578 8.77578 6.65339 9.01946 6 9.01946C5.34661 9.01946 4.71422 8.77578 4.24334 8.33319C3.77141 7.8896 3.5 7.28112 3.5 6.63959C3.5 5.99807 3.77142 5.38958 4.24334 4.946Z",
    stroke: "#848A9B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacepin);
export default __webpack_public_path__ + "static/media/placepin.cc1d1496276ed0b21f84b5225584d9e5.svg";
export { ForwardRef as ReactComponent };